import Overview from './overview';
import TransferAdmissionsContact from './transferAdmissionsContact';
import TransferApplicationRequirements from './transferApplicationRequirements';
import TransferCreditPolicies from './transferCreditPolicies';
import Website from './website';
import CreditsNotAccepted from './creditsNotAccepted';
import CreditCap from './creditCap';
import AcademicResidency from './academicResidency';
import withCollegeService from '../withCollegeService';
import UndergraduateStudents from './undergraduateStudents';
import SupportServicesWebsite from './supportServicesWebsite';
import FinancialAidInfoWebsite from './financialAidInfoWebsite';
import ScholarshipAvailability from './scholarshipAvailability';
import EightYearGraduationRate from './eightYearGraduationRate';
import CreditTransferInfoWebsite from './creditTransferInfoWebsite';
import ArticulationAgreements from './articulationAgreements';
import DualAdmissionsPrograms from './dualAdmissionsPrograms';
import EnrollmentTerms from './enrollmentTerms';
import CollegeSystems from './collegeSystems';

const TransferWebsite = withCollegeService(Website, 'transferInfo.website', '', {
  value: 'field_he_xfer_info_url',
});

const TransferSupportWebsite = withCollegeService(SupportServicesWebsite, 'transferInfo.supportWebsite', '', {
  value: 'field_he_xfer_support_url',
});

const TransferFinancialAidInfoWebsite = withCollegeService(
  FinancialAidInfoWebsite,
  'transferInfo.financialAidInfoWebsite',
  '',
  {
    value: 'field_he_xfer_fin_aid_url',
  },
);

const TransferOverview = withCollegeService(
  Overview,
  'transferInfo.overview',
  '',
  { value: 'field_he_xfer_overview' },
);

const TransferCreditTransferInfoWebsite = withCollegeService(
  CreditTransferInfoWebsite,
  'transferInfo.creditTransferInfoWebsite',
  '',
  {
    value: 'field_he_xfer_credit_info_url',
  },
);

const TransferAcademicResidency = withCollegeService(
  AcademicResidency,
  'transferInfo.academicResidency',
  '',
  {
    value: 'field_he_xfer_min_home_credits',
  },
);

const TransferCreditCap = withCollegeService(
  CreditCap,
  'transferInfo.creditCap',
  '',
  {
    value: 'field_he_xfer_credit_cap',
  },
);

const TransferCreditsNotAccepted = withCollegeService(
  CreditsNotAccepted,
  'transferInfo.creditsNotAccepted',
  '',
  {
    value: 'field_he_xfer_cr_not_acc',
  },
);

const TransferScholarshipAvailability = withCollegeService(
  ScholarshipAvailability,
  'transferInfo.scholarshipAvailability',
  '',
  {
    value: 'field_he_xfer_scholarships_avbl',
  },
);

const TransferUndergraduateStudents = withCollegeService(
  UndergraduateStudents,
  'transferInfo.undergraduateStudents',
  '',
  {
    value: 'field_he_xfer_in_enrollment',
  },
);

const TransferEightYearGraduationRate = withCollegeService(
  EightYearGraduationRate,
  'transferInfo.eightYearGradRate',
  '',
  {
    value: 'field_he_xfer_ft_8yr_grad_rate',
  },
);

const TransferEnrollmentTerms = withCollegeService(
  EnrollmentTerms,
  'transferInfo.enrollmentTerms',
  '',
  {
    value: 'field_he_xfer_sems_transfer',
  },
);

const TransferCollegeSystems = withCollegeService(
  CollegeSystems,
  'transferInfo.collegeSystems',
  '',
  {
    value: 'field_he_coll_uni_sys',
  },
);

export {
  // eslint-disable-next-line import/prefer-default-export
  TransferOverview,
  TransferAdmissionsContact,
  TransferApplicationRequirements,
  TransferCreditPolicies,
  TransferWebsite,
  TransferCreditCap,
  TransferCreditsNotAccepted,
  TransferSupportWebsite,
  TransferAcademicResidency,
  TransferUndergraduateStudents,
  TransferEightYearGraduationRate,
  TransferFinancialAidInfoWebsite,
  TransferScholarshipAvailability,
  TransferCreditTransferInfoWebsite,
  ArticulationAgreements as TransferArticulationAgreements,
  DualAdmissionsPrograms,
  TransferEnrollmentTerms,
  TransferCollegeSystems,
};
